export default __webpack_public_path__ + "static/media/80.b23ea48f.gif";